import axios, {AxiosResponse} from 'axios'
import {DownloadRequestQueryResponse} from './_models'
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const BASE_URL = `${API_URL}/download-requests`

// isKpi=true  → GET /api/kpi/download-requests
// isKpi=false → GET /api/download-requests
export const createGetDownloadRequests =
  (isKpi: boolean) =>
  (query: string): Promise<DownloadRequestQueryResponse> => {
    const url = isKpi
      ? `${API_URL}/kpi/download-requests?${query}`
      : `${API_URL}/download-requests?${query}`
    return axios.get(url).then((d: AxiosResponse<DownloadRequestQueryResponse>) => d.data)
  }

export const downloadRequest = async (id: number, isKpi: boolean): Promise<void> => {
  const url = isKpi
    ? `${API_URL}/kpi/download-requests/${id}/download`
    : `${BASE_URL}/${id}/download`
  const response = await axios.get(url, {responseType: 'blob'})

  const contentDisposition = response.headers['content-disposition'] ?? ''
  const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
  const fileName = match ? match[1].replace(/['"]/g, '') : 'relatorio.xlsx'

  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}
